// extracted by mini-css-extract-plugin
export default {"container":"MenuOverlay_container__lS7td","group":"MenuOverlay_group__cz2q+","joysticks":"MenuOverlay_joysticks__7SJJS"};